document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.become-customer-form');

  if(!formContainer) {
    return false;
  }

  const apiSubDomain = window.location.hostname === "bakeryboxcom-dev.myshopify.com" ? 'gmb-dev.mtnhauslabs.com' : 'api.bakerybox.com';

  async function fetchUser(form) {
    const response = await fetch(`https://${apiSubDomain}/api/customer/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: form.elements.email.value,
        phone: form.elements.phone_number.value === "+1 " ? "" : form.elements.phone_number.value,
      })
    });
    return await response.json();
  }

  let canSubmit = false;

  const observer = new MutationObserver(mutation => {
    const formEmbed = document.getElementById('app-embed');

    if(!formEmbed) return false;

    const form = formEmbed.shadowRoot.querySelector('form');
    const button = form.querySelector('[type="submit"]');

    observer.disconnect();

    form.email.addEventListener('change', (event) => {
      canSubmit = false;
    });

    button.addEventListener('click', (e) => {
      if(canSubmit) {
        return;
      }

      if(form.elements.email.value) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        button.innerHTML = 'VALIDATING';

        fetchUser(form).then((response) => {
          if(response.status) {
            canSubmit = true;
            setTimeout(() => {
              button.click();
            }, 100)
          } else {
            new Modal({
              title: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>`,
              text: 'An account with this email or phone number already exists. Please sign in with your original credentials or email <a href="mailto:Sales@BakeryBox.com">Sales@BakeryBox.com</a>.',
              immediate: true,
              className: ['modal--error']
            });
          }

          button.innerHTML = 'SUBMIT';
        });
      }
    }, {
      capture: true
    });
  });

  observer.observe(formContainer, {
    childList: true,
    subtree: true
  });
});
